import home from "./dashboard";

const teacher = {
  home
}

export default teacher